import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import UnauthorizedError from 'api/errors/UnauthorizedError';
import useAuth from './useAuth';

function useProtectedMutation<
  TData = unknown,
  TError = unknown,
  TVariables = unknown,
  TContext = unknown,
>(
  mutationFn: (variables: TVariables) => Promise<TData>,
  config?: UseMutationOptions<TData, TError, TVariables, TContext>,
): UseMutationResult<TData, TError, TVariables, TContext> {
  const { triggerUnauthorized } = useAuth();

  const extendedConfig: UseMutationOptions<
    TData,
    TError,
    TVariables,
    TContext
  > = {
    ...config,
    onError: (error: TError, variables: TVariables, context?: TContext) => {
      if (error instanceof UnauthorizedError) {
        triggerUnauthorized();
        return;
      }

      if (config && config.onError) {
        config.onError(error, variables, context);
      }
    },
  };

  return useMutation<TData, TError, TVariables, TContext>(
    mutationFn,
    extendedConfig,
  );
}

export default useProtectedMutation;
